import React, { useState } from 'react';
import api from '../services/api';
import { FiUserPlus } from 'react-icons/fi';

const SaveContactModal = ({ phoneNumber, onSaved, onClose }) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSave = async () => {
    if (!firstName.trim()) { setError('الاسم الاول مطلوب'); return; }
    setLoading(true); setError('');
    try {
      // Unified client store: new saves go to the CRM `clients` table, not the
      // legacy `contacts` table. /api/contacts still exists and its historical
      // data is still readable — it just no longer receives NEW writes.
      await api.put(`/clients/${encodeURIComponent(phoneNumber)}`, {
        full_name: [firstName.trim(), lastName.trim()].filter(Boolean).join(' ')
      });
      onSaved(firstName.trim() + ' ' + lastName.trim());
      onClose();
    } catch (e) {
      setError(e.response?.data?.error || 'حدث خطا');
    }
    setLoading(false);
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 12, width: 420, maxWidth: '90vw', boxShadow: '0 20px 60px rgba(0,0,0,0.2)', overflow: 'hidden' }}>
        <div style={{ background: '#1e40af', padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 22, cursor: 'pointer', lineHeight: 1 }}>&times;</button>
          <h3 style={{ margin: 0, color: '#fff', display: 'flex', alignItems: 'center', gap: 8, fontSize: 16 }}>
            <FiUserPlus /> حفظ عميل جديد
          </h3>
        </div>
        <div style={{ padding: 24 }}>
          <div style={{ background: '#f0f9ff', padding: 14, borderRadius: 8, marginBottom: 20, textAlign: 'center', fontWeight: 700, fontSize: 18, direction: 'ltr', color: '#1e40af', border: '1px solid #bfdbfe' }}>
            {phoneNumber}
          </div>
          {error && <div style={{ color: '#dc2626', marginBottom: 12, fontSize: 13, background: '#fef2f2', padding: 8, borderRadius: 6 }}>{error}</div>}
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 6, fontSize: 14, fontWeight: 600, color: '#334155' }}>الاسم الاول *</label>
            <input
              value={firstName} onChange={e => setFirstName(e.target.value)}
              style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 15, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' }}
              placeholder="ادخل الاسم الاول"
              autoFocus
              onFocus={e => e.target.style.borderColor = '#3b82f6'}
              onBlur={e => e.target.style.borderColor = '#d1d5db'}
            />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', marginBottom: 6, fontSize: 14, fontWeight: 600, color: '#334155' }}>اسم العائلة</label>
            <input
              value={lastName} onChange={e => setLastName(e.target.value)}
              style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 15, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' }}
              placeholder="اختياري"
              onFocus={e => e.target.style.borderColor = '#3b82f6'}
              onBlur={e => e.target.style.borderColor = '#d1d5db'}
            />
          </div>
          <button
            style={{ width: '100%', padding: '12px 0', background: loading ? '#93c5fd' : '#1e40af', color: '#fff', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit' }}
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? 'جاري الحفظ...' : 'حفظ العميل'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveContactModal;
